/**
 * Created by claudio iozzia on 07/07/2017.
 */
import {Range} from '../../../../common/Range';
import {tassign, Utils} from "../../../../common/utils";
import {Ic} from "../../../../models/common";
import {siPrefix} from "../../../../common/siPrefix";
import {ValueFormatter} from "../../../../common/ValueFormatter";
import {Flyback} from "../../../POWER/acdc/flyback";
import {IAppSpec} from "../../../../Redux/selector.state";
import {NumLEDBounds} from "../NumLEDBounds";
import {EMPTY_NOTE_LED, INoteLed, Validator_LED_Common} from "../../../../models/validator/validator_led_common";

export class Validator_AcLed_FlyBack extends Validator_LED_Common {
  protected static toRange(a: number, b: number): Range {
    return new Range(
      ValueFormatter.scale(a, siPrefix.unit, 2, "c")
      , ValueFormatter.scale(b, siPrefix.unit, 2, "f")
    );
  }

  private static allowed_nLED(allow_nS_nP: Function, nS: Range, nP: Range): Range[] {
    let minS: number = Number.POSITIVE_INFINITY;
    let maxS: number = Number.NEGATIVE_INFINITY;

    let minP: number = Number.POSITIVE_INFINITY;
    let maxP: number = Number.NEGATIVE_INFINITY;

    for (let s: number = nS.min; s <= nS.max; s++) {
      for (let p: number = nP.min; p <= nP.max; p++) {
        if (allow_nS_nP(s, p)) {
          if (s < minS) {
            minS = s;
          }
          if (maxS < s) {
            maxS = s;
          }
          if (p < minP) {
            minP = p;
          }
          if (maxP < p) {
            maxP = p;
          }
        }
      }
    }

    return [new Range(minS, maxS, false), new Range(minP, maxP, false)];
  }

  protected getVoutBounds(ic: Ic): Range {
    return new Range(ic.vout_min, ic.vout_max);
  }

  protected getPoutBounds(ic: Ic, spec: IAppSpec): Range {
    const _vin = spec.spec.value.input;
    const powerUpperBound: number = Flyback.maxLimPower(ic, _vin.min * Math.SQRT2) * 5 / 6;
    return Validator_AcLed_FlyBack.toRange(0, powerUpperBound);
  }

  private caso_noVF_noIF(ic: Ic, spec: IAppSpec): INoteLed {
    const _led_out = spec.spec.value.output.outputs[0];
    const iDetails: INoteLed = tassign(EMPTY_NOTE_LED);

    const ubs: NumLEDBounds = NumLEDBounds.getIt(ic);

    // V1: Dominio per PLoad - Power Out
    const P: Range = this.getPoutBounds(ic, spec);

    // V2: Dominio per VLoad - VOut
    const V: Range = this.getVoutBounds(ic);

    // V5: Dominio per ILoad
    const I: Range = Validator_AcLed_FlyBack.toRange(P.min / V.max, P.max / V.min);

    const nS: Range = new Range(1, ubs.series);
    const vfD: Range = Validator_AcLed_FlyBack.toRange(V.min / nS.max, V.max / nS.min);

    iDetails.VF = Utils.acceptInRange(_led_out.voltage, vfD.min, vfD.max, "VF", "V", "should");

    // V4: parallel Domain
    const nP: Range = new Range(1, ubs.parallel);
    const ifD: Range = Validator_AcLed_FlyBack.toRange(I.min / nP.max, I.max / nP.min);
    iDetails.IF = Utils.acceptInRange(_led_out.current, ifD.min, ifD.max, "IF", "A", "should");

    return iDetails;
  }

  private caso_noIF(ic: Ic, spec: IAppSpec): INoteLed {
    const _led_out_val = spec.spec.value.output.outputs[0];
    const _led_out_param = spec.spec.value.output.ledParam;
    const iDetails: INoteLed = tassign(EMPTY_NOTE_LED);

    const ubs: NumLEDBounds = NumLEDBounds.getIt(ic);

    // V1: Dominio per PLoad - Power Out
    const P: Range = this.getPoutBounds(ic, spec);
    // V2: Dominio per VLoad - VOut
    const V: Range = this.getVoutBounds(ic);
    // V5: Dominio per ILoad
    const I: Range = Validator_AcLed_FlyBack.toRange(P.min / V.max, P.max / V.min);

    const nS: Range = new Range(1, ubs.series);
    const vfD: Range = Validator_AcLed_FlyBack.toRange(V.min / nS.max, V.max / nS.min);
    iDetails.VF = Utils.acceptInRange(_led_out_val.voltage, vfD.min, vfD.max, "VF", "V", "should");

    const adviseIF = function (I: Range): void {
      // V4: parallel Domain
      const nP: Range = new Range(1, ubs.parallel);
      const ifD: Range = Validator_AcLed_FlyBack.toRange(I.min / nP.max, I.max / nP.min);
      iDetails.IF = Utils.acceptInRange(_led_out_val.current, ifD.min, ifD.max, "with the defined VF,\nIF", "A", "should");

      if (!Utils.isValueEmpty(_led_out_val.current) && iDetails.IF === null) {
        // posso dare errore su parallel soltanto se ho esplicitato IF e questo è attendibile cioè non ha errori di dominio
        const IF: number = _led_out_val.current;
        const nP1: Range = Validator_AcLed_FlyBack.toRange(
          Math.max(nP.min, I.min / IF)
          , Math.min(nP.max, I.max / IF)
        ).ofInt;

        iDetails.Parallel = Validator_LED_Common.validate_num(_led_out_param.parallel, nP1, "number of strings", nP);
      }

    };

    const VF: number = _led_out_val.voltage;
    const vout: number = VF * _led_out_param.serial;
    iDetails.Vout = Utils.acceptInRange(vout, V.min, V.max, "VLoad", "V", "should");

    if (iDetails.VF === null) {
      const nS1: Range = nS.intersect(Validator_AcLed_FlyBack.toRange(V.min / VF, V.max / VF)).ofInt;
      const V1: Range = V.intersect(Validator_AcLed_FlyBack.toRange(VF * nS1.min, VF * nS1.max));

      iDetails.Serial = Validator_LED_Common.validate_num(_led_out_param.serial, nS1, "number of led in series", nS);
      adviseIF(I.intersect(Validator_AcLed_FlyBack.toRange(P.min / V1.max, P.max / V1.min)));
    } else {
      iDetails.Serial = Validator_LED_Common.validate_num(_led_out_param.serial, nS, "number of led in series", nS);
      adviseIF(I);
    }

    return iDetails;
  }

  private caso_noVF(ic: Ic, spec: IAppSpec): INoteLed {
    const _led_out_val = spec.spec.value.output.outputs[0];
    const _led_out_param = spec.spec.value.output.ledParam;
    const iDetails: INoteLed = tassign(EMPTY_NOTE_LED);

    const ubs: NumLEDBounds = NumLEDBounds.getIt(ic);

    // V1: Dominio per PLoad - Power Out
    const P: Range = this.getPoutBounds(ic, spec);
    // V2: Dominio per VLoad - VOut
    const V: Range = this.getVoutBounds(ic);
    // V5: Dominio per ILoad
    const I: Range = Validator_AcLed_FlyBack.toRange(P.min / V.max, P.max / V.min);

    // V4: parallel Domain
    const nP: Range = new Range(1, ubs.parallel);
    const ifD: Range = Validator_AcLed_FlyBack.toRange(I.min / nP.max, I.max / nP.min);
    iDetails.IF = Utils.acceptInRange(_led_out_val.current, ifD.min, ifD.max, "IF", "A", "should");

    const adviseVF: Function = function (V: Range): void {
      // V4: parallel Domain
      const nS: Range = new Range(1, ubs.series);
      const vfD: Range = Validator_AcLed_FlyBack.toRange(V.min / nS.max, V.max / nS.min);
      iDetails.VF = Utils.acceptInRange(_led_out_val.voltage, vfD.min, vfD.max, "with the defined IF,\nVF", "V", "should");
    };

    if (iDetails.IF === null) {
      const IF: number = _led_out_val.current;

      const nP1: Range = Validator_AcLed_FlyBack.toRange(
        Math.max(nP.min, I.min / IF)
        , Math.min(nP.max, I.max / IF)
      ).ofInt;
      const I1: Range = Validator_AcLed_FlyBack.toRange(
        Math.max(I.min, IF * nP1.min)
        , Math.min(I.max, IF * nP1.max)
      );

      adviseVF(V.intersect(Validator_AcLed_FlyBack.toRange(P.min / I1.max, P.max / I1.min)));
      iDetails.Parallel = Validator_LED_Common.validate_num(_led_out_param.parallel, nP1, "number of strings", nP);
    } else {
      adviseVF(V);
      iDetails.Parallel = Validator_LED_Common.validate_num(_led_out_param.parallel, nP, "number of strings", nP);
    }

    return iDetails;
  }

  private caso_VF_IF(ic: Ic, spec: IAppSpec): INoteLed {
    const _led_out_val = spec.spec.value.output.outputs[0];
    const _led_global_val = spec.spec.value.output.globalOutput;
    const _led_out_param = spec.spec.value.output.ledParam;
    const iDetails: INoteLed = tassign(EMPTY_NOTE_LED);

    const ubs: NumLEDBounds = NumLEDBounds.getIt(ic);

    // V1: Dominio per PLoad - Power Out
    const P: Range = this.getPoutBounds(ic, spec);
    // V2: Dominio per VLoad - VOut
    const V: Range = this.getVoutBounds(ic);

    // V5: Dominio per ILoad
    const I: Range = Validator_AcLed_FlyBack.toRange(P.min / V.max, P.max / V.min);

    const nS: Range = new Range(1, ubs.series);
    const vfD: Range = Validator_AcLed_FlyBack.toRange(V.min / nS.max, V.max / nS.min);

    const nP: Range = new Range(1, ubs.parallel);
    const ifD: Range = Validator_AcLed_FlyBack.toRange(I.min / nP.max, I.max / nP.min);

    iDetails.VF = Utils.acceptInRange(_led_out_val.voltage, vfD.min, vfD.max, "VF", "V", "should");
    iDetails.IF = Utils.acceptInRange(_led_out_val.current, ifD.min, ifD.max, "IF", "A", "should");

    // Per validaer il lef devono essere soddisfatte la V1 e V2

    const vout: number = _led_global_val.voltage; // VF * numSerie;
    iDetails.Vout = Utils.acceptInRange(vout, V.min, V.max, "VLoad", "V", "should");


    const pOut: number = ValueFormatter.scale(_led_global_val.power, siPrefix.unit);
    iDetails.Pout = Utils.acceptInRange(pOut, P.min, P.max, "PLoad", "W", "should");

    validate_nLED(nS, nP, function (s: number, p: number): boolean {
      return P.contains(p * s * _led_out_val.power)
        && V.contains(s * _led_out_val.voltage);
    });

    function validate_nLED(nS: Range, nP: Range, allow_nS_nP: Function): void {
      const n = Validator_AcLed_FlyBack.allowed_nLED(allow_nS_nP, nS, nP);
      const nS1: Range = n[0];
      const nP1: Range = n[1];

      if (!nS1.isEmpty && !nP1.isEmpty) {
        iDetails.Serial = Validator_LED_Common.validate_num(_led_out_param.serial, nS1, "number of led in series", nS);
        iDetails.Parallel = Validator_LED_Common.validate_num(_led_out_param.parallel, nP1, "number of strings", nP);
      } else {
        let errKey: string;

        if (iDetails.Vout !== null || iDetails.Pout !== null) {
          errKey = 'selected led cannot be used verify and review';
        } else {
          console.log("Strange: Vload nor Pload has errors but there not exists nS nor nP");
          errKey = 'selected led cannot be used review';
        }

        iDetails.VF = iDetails.IF = { key: errKey };
      }
    }

    return iDetails;
  }

  protected validation(ic: Ic, spec: IAppSpec): INoteLed {
    const _out = spec.spec.value.output.outputs[0];
    const cases: number = (Utils.isValueEmpty(_out.voltage) ? 0 : 1) + (Utils.isValueEmpty(_out.current) ? 0 : 2);

    const baseValidation = super.validation(ic, spec);
    if (baseValidation.VF || baseValidation.IF || baseValidation.Rd) {
      return baseValidation;
    }

    switch (cases) {
      case 0:
        return this.caso_noVF_noIF(ic, spec); // caso_noVF_noIF(ic, iDetails);
      case 1:
        return this.caso_noIF(ic, spec);  // caso_noIF(ic, iDetails);
      case 2:
        return this.caso_noVF(ic, spec);  // caso_noVF(ic, iDetails);
      case 3:
        return this.caso_VF_IF(ic, spec); // caso_VF_IF(ic, iDetails);
    }
  }
}
